module.exports = __webpack_public_path__ + "img/rascrut-13.cb9f6e46.webp";